import ReactHtmlParser from 'react-html-parser';

export function CourseWizardResultsItem(props) {

  const className = [
    'border',
    'border-sai-gray',
    'border-solid',
    'box-border',
    'has-background',
    'has-white-background-color',
    'mb-0',
    'p-8',
    'rounded-md',
    'shadow-inner-left-sai-navy',
    'wp-block-group',
    !props.isVisible ? 'hidden' : ''
  ].filter(str => str).join(" ");
  return (
    <div className={className}>
      <div className="wp-block-group__inner-container">

        <div>
          <div className="wp-block-group__inner-container">

            <div className="gap-4 grid grid-cols-12 m-0">

              <div className="col-span-2">
                <img src={props.thumbnailUrl} alt="Agile Product Management Course Thumbnail" />
              </div>


              <div className="col-span-10">

                <h3 className="text-xl font-sans text-navy has-text-color">{props.title.rendered}</h3>


                <p className="mb-2 text-base font-sans text-gray-dark has-text-color">{props.acf.course_certification_excerpt}</p>

                {ReactHtmlParser(props.excerpt.rendered)}







                <div className="wp-block-buttons grid grid-flow-col justify-start gap-2 items-center m-0">

                  <div className="wp-block-button text-base font-sans">
                    <a className="wp-block-button__link icon-position--before" href={props.link}>{props.acf.learn_more_button_label}</a>
                  </div>


                  <div className="wp-block-button text-base font-sans">
                    <a className="wp-block-button__link icon-position--before" href={`/training/calendar/?course_id=${props.title.rendered.replace('®', '')}`}>{props.acf.find_training_button_label}</a>
                  </div>

                </div>
              </div>

            </div>

          </div>
        </div>

      </div>
    </div>
  );
}